import { AttachmentService } from 'src/app/services/attachment.service';
import { SelectedVehicleService } from './../../../services/selectedVehicle.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { Vehicle } from './../../../models/Vehicle';
import { CrossBorderModel } from './../../../models/Booking/CrossBorderModel';
import { OneWayRentalModel } from './../../../models/Booking/OneWayRentalModel';
import { DriverSkillModel } from './../../../models/Booking/DriverSkillModel';
import { element } from 'protractor';
import { SearchService } from 'src/app/services/search.service';
import { BookingService } from './../../../services/booking.service';
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewChild } from '@angular/core';
import { faRoad, faClipboard, faDollarSign, faListAlt, faMapMarkerAlt, faPlusCircle, faCar } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { Directive, HostListener } from '@angular/core';





import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { faBatteryHalf } from '@fortawesome/free-solid-svg-icons';
import { VehicleReservationCaseDetailsPramModel } from 'src/app/models/VehicleReservationCaseDetailsPramModel';
import { VehicleReservationCaseDetailsModel, LstAdditionalServiceReservationCase, LstPolicyReservationCaseModel, LstVehicleReservationCaseNonWorkingHoursChargeModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { PredefinedAdditionalServiceEnum, AdditionalServiceType, PolicyType, DepositPolicyPaymentTypes, CancelationPolicyChargeTypes, FuelChargingPolicyTypes, ExceededDistancePolicyTypes, AgeRestrictionPolicyTypes, AmountPolicyTypes, AppliedRateTypeID, ExtensionRules, SecurityDepositType, RentalContractTerminationPeriodTypes, AllowedReplacementTypeID, AppliedChargingRate, ModeType, AppliedChargingRateOnExtendedPeriod, AgencyReturnLocationTypes } from 'src/app/models/enums/BookingEnums';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { GoogleMapPinComponent } from 'src/app/views/booking/google-map-pin/google-map-pin.component';
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { EvaluationSummaryModel } from 'src/app/models/Evaluation/EvaluationSummaryModel';
import { EvaluationLogsMasterModel } from 'src/app/models/Evaluation/EvaluationLogsMasterModel';
import { faBusinessTime, faHandPointUp, faCalendar, faCalendarAlt, faArrowLeft, faBriefcase, faGasPump, faUser, faKey, faTags, faBan } from '@fortawesome/free-solid-svg-icons';
import { UpdateReservationSearchByAgencyResult } from 'src/app/models/Booking/UpdateReservationSearchByAgencyResult';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';
import { FindYourIdealCarModel } from 'src/app/models/Booking/FindYourIdealCarModel';
import { LoadingService } from 'src/app/services/loading.service';
import { EvaluationParmModel } from 'src/app/models/Evaluation/EvaluationParmModel';
import { EvaluationDomainTemplateScopeEnum } from 'src/app/models/enums/Evaluation/EvaluationEnums'
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { IconService } from './../../../services/icon.service';
import { Subscription } from 'rxjs';
import { MatTabGroup } from '@angular/material/tabs';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class BookingDetailsComponent implements OnInit, OnDestroy {

  @Input() bookingData: any;
  //@Input() form: FormGroup;
  form: FormGroup;
  TermsAndCondition;
  faBatteryHalf = faBatteryHalf;
  faMapMarkerAlt = faMapMarkerAlt;
  faPlusCircle = faPlusCircle;
  faTimesCircle = faTimesCircle;
  faDollarSign = faDollarSign;
  faClipboard = faClipboard;
  faCar = faCar;
  faListAlt = faListAlt;
  vehicleReservationCaseDetailsModel: VehicleReservationCaseDetailsModel;
  borders: FormArray;
  formControlPrefix = 's_';
  formControlTotalPostfix = '_total';
  formControlTogglePostfix = '_toggle';
  driverSkills: DriverSkillModel[] = [];
  oneWayRentalLocations: OneWayRentalModel[] = [];
  crossBorders: CrossBorderModel[] = [];
  selectedBorders: CrossBorderModel[] = [];
  lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[];
  currency;
  //Flag for One Way Rental : PickUpLocation and DropUp Location
  pickupLocationFlag: boolean = true;
  returnLocationFlag: boolean = true;
  //search Model
  searchModel: VehicleReservationSearchParm;
  faBan = faBan;
  faRoad = faRoad;
  faHandPointUp = faHandPointUp;
  faCalendarAlt = faCalendarAlt;
  faCalendar = faCalendar;
  faBusinessTime = faBusinessTime;

  showExistBorder: boolean = false;


  //Vehice
  vehicle: Vehicle;

  //Evaluation Models
  evaluationSummary: EvaluationSummaryModel;
  evaluationLogsMasterList: EvaluationLogsMasterModel[];
  customerID: any;
  @Input() submittedData;
  submitted: boolean = false;
  tabSelectedIndex = 0;

  oneWayRentalFlag: boolean = false;

  //Validation Helper Variables
  rentalDeliveryErrors: boolean = false;

  subscriptions: Subscription[] = [];
  oneWayRentalServiceID: string;
  selectedOneWayRentalService: OneWayRentalModel;

  constructor(
    private _dateFormatPipe: DateFormatPipe,
    private authService: AuthService,
    private loaderService: LoadingService,
    private selectedVehicleService: SelectedVehicleService,
    private attachmentService: AttachmentService,
    private router: Router,
    service: SearchService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private bookingService: BookingService,
    private searchService: SearchService,
    private iconService: IconService,
    private notifications: NotificationsService,
    private translate: TranslateService) {
    this.currency = service.getCurrency();
    this.matIconRegistry.addSvgIcon(
      "steeringWheel",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.steeringWheel)
    );
    this.matIconRegistry.addSvgIcon(
      "childSeats",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.childSeats)
    );
    this.matIconRegistry.addSvgIcon(
      "GPSNavigation",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.GPSNavigation)
    );
    this.matIconRegistry.addSvgIcon(
      "additionalService",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.additionalService)
    );


  }


  @ViewChild("tab", { static: false }) tab: MatTabGroup;

  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  crossingBorders = [

  ];


  //#region  Policies Enum

  public get predefinedAdditionalServiceEnum(): typeof PredefinedAdditionalServiceEnum {
    return PredefinedAdditionalServiceEnum;
  }

  public get additionalServiceType(): typeof AdditionalServiceType {
    return AdditionalServiceType;
  }

  public get policyType(): typeof PolicyType {
    return PolicyType;
  }
  public get depositPolicyPaymentTypes(): typeof DepositPolicyPaymentTypes {
    return DepositPolicyPaymentTypes;
  }
  public get appliedChargingRate(): typeof AppliedChargingRate {
    return AppliedChargingRate;
  }
  public get cancelationPolicyChargeTypes(): typeof CancelationPolicyChargeTypes {
    return CancelationPolicyChargeTypes;
  }
  public get allowedReplacementTypeID(): typeof AllowedReplacementTypeID {
    return AllowedReplacementTypeID;
  }
  public get fuelChargingPolicyTypes(): typeof FuelChargingPolicyTypes {
    return FuelChargingPolicyTypes;
  }

  public get rentalContractTerminationPeriodTypes(): typeof RentalContractTerminationPeriodTypes {
    return RentalContractTerminationPeriodTypes;
  }

  public get exceededDistancePolicyTypes(): typeof ExceededDistancePolicyTypes {
    return ExceededDistancePolicyTypes;
  }

  public get extensionRules(): typeof ExtensionRules {
    return ExtensionRules;
  }
  public get appliedChargingRateOnExtendedPeriod(): typeof AppliedChargingRateOnExtendedPeriod {
    return AppliedChargingRateOnExtendedPeriod;
  }
  public get ageRestrictionPolicyTypes(): typeof AgeRestrictionPolicyTypes {
    return AgeRestrictionPolicyTypes;
  }
  public get amountPolicyTypes(): typeof AmountPolicyTypes {
    return AmountPolicyTypes;
  }

  public get appliedRateTypeID(): typeof AppliedRateTypeID {
    return AppliedRateTypeID;
  }

  public get securityDepositType(): typeof SecurityDepositType {
    return SecurityDepositType;
  }
  //#endregion



  //Handle the crossing border plus button
  //Add a new groupForm into the crossing border dynamic control
  addCrossingBorderToForm(additionalService: LstAdditionalServiceReservationCase, index) {


    let borderObj = this.form.controls['s_' + additionalService.additionalServiceID];

    let borderArray = this.form.controls['s_' + additionalService.additionalServiceID + '_Borders'] as FormArray;


    //IF No Border Selected then skip the event
    if (borderObj.value == null || Object.keys(borderObj.value).length == 0) {
      return;
    }

    //If Item not added before
    if (this.selectedBorders.indexOf(borderObj.value, 0) == -1) {
      let border = borderObj.value;
      let borderChargeValue = border.charge;
      //IF insurance extention is active
      // if (border.isNewInsurence) {
      //   borderChargeValue += border.increase;
      // }
      borderArray.push(new FormGroup({
        BorderName: new FormControl(borderObj.value['borderPortName']),
        BorderValue: new FormControl(borderChargeValue),
        BorderObj: new FormControl(borderObj.value)
      }));
      this.borders = borderArray;

      this.selectedBorders.push(borderObj.value);
      //this.crossBorders.push(this.crossBorders[index]);
      //this.crossBorders.splice(index, 1);
      this.changeForm(this.form);
      this.showExistBorder = false;
    }
    else {
      this.showExistBorder = true;
    }
  }

  deleteCrosingBorder(x) {
    let crossborder = this.borders.value[x].BorderObj as CrossBorderModel;
    this.selectedBorders = this.selectedBorders.filter(a => a.countryBorderPortsID != crossborder.countryBorderPortsID);
    this.borders.removeAt(x);

    this.crossingBorders.splice(x, 1);
    this.changeForm(this.form);

  }

  ngOnInit() {
    this.subscriptions.push(this.bookingData.subscribe(data => {
      this.form = data;
      this.cd.markForCheck();
    }));
    this.subscriptions.push(this.submittedData.subscribe(res => {


      //IF the new value different than the current
      if (this.submitted != res) {
        this.submitted = res;
        this.cd.markForCheck();
      }
      if (this.form.invalid) {
        const tabGroup = this.tab;
        if (!tabGroup || !(tabGroup instanceof MatTabGroup)) return;

        const tabCount = tabGroup._tabs.length;
        //tabGroup.selectedIndex = (tabGroup.selectedIndex + 1) % tabCount;
        tabGroup.selectedIndex = 0;
        this.cd.markForCheck();
      }

    }));

    this.subscriptions.push(this.searchService.searchModel.subscribe(res => {

      if (res != null) {
        this.searchModel = res;
        /*   this.form=new FormGroup({
            secondCtrl:new FormControl('')
          });
          this.changeForm(this.form); */
      }



      this.subscriptions.push(this.selectedVehicleService.vehicle.subscribe(res => {

        this.subscriptions.push(this.authService.loggedInCustomer.subscribe(res => {
          if (res != null)
            this.customerID = res.customerID;
        }))


        if (res != null) {

          this.vehicle = res;
          try {

            this.loaderService.show();
            this.buildForm();
            this.loaderService.hide();

          } catch (error) {

          }

        }

      }));
      // })

    }));

    this.subscriptions.push(this.bookingService.findYourIdealCar.subscribe(res => {
      if (res != null) {

        this.searchModel = res.searchModel;

        this.updateVehicleReservationDetailsRequest(res.findYourIdealCarModel);
        this.buildForm();

      }
    }))
    this.loadTermsAndCondition();


  }


  updateVehicleReservationDetailsRequest(res: FindYourIdealCarModel) {

    this.vehicle.durationUnitName = res.DurationUnitName;
    this.vehicle.vehiclePrice = res.TotalRentalPriceNewDuration;


    // this.searchModel.StartDateString = res.StartDateString;

    // this.searchModel.StartTimeString = res.StartTimeString,
    // this.searchModel.EndDateString = res.EndDateString;
    // this.searchModel.EndTimeString = res.EndTimeString,

    // this.searchModel.ToAgencyID = res.ToAgencyID;
    // this.searchModel.DropOffLocationTypeID = res.DropOffLocationTypeID;
    // this.searchModel.DropOffLocationID = res.ToAgencyID;
    // this.searchModel.DropUpLocationAgencyId = res.ToAgencyID;

    //this.vehicle.membershipID,
    //this.vehicle.campaignID,

    //this.vehicle.pricingRuleID
    // this.buildForm();
  }


  buildForm() {



    let vehicleReservationCaseDetailsPram = {
      agencyID: this.searchModel.AgencyID,
      startDateString: this.searchModel.StartDateString,
      classID: this.vehicle.classID,
      makeID: this.vehicle.makeID,
      modelID: this.vehicle.modelID,
      year: this.vehicle.year,
      vehicleID: this.vehicle.vehicleID,
      contractTypeID: this.vehicle.contractTypeID,
      startTimeString: this.searchModel.StartTimeString,
      endDateString: this.searchModel.EndDateString,
      endTimeString: this.searchModel.EndTimeString,
      membershipID: this.vehicle.membershipID,
      campaignID: this.vehicle.campaignID,
      customerID: this.customerID,
      pricingRuleID: this.vehicle.pricingRuleID,
      DropOffLocationTypeID: this.searchModel.DropOffLocationTypeID,
      DropOffLocationID: this.searchModel.DropOffLocationID
    }




    this.bookingService.getVehicleReservationCaseDetails(vehicleReservationCaseDetailsPram).subscribe(res => {
      if (res != null) {





        this.vehicleReservationCaseDetailsModel = res;

        console.log(res)
        if (res.vehicleReservationCaseRentalPeriodModel[0] != null) {
          this.vehicle.vehiclePrice = res.vehicleReservationCaseRentalPeriodModel[0].rentalUnitPrice;
        }




        //If the pickup Same as DropOff then rentalDelivery reuturn lat,lnt is same as pickup


        if (this.searchModel.AgencyID == this.searchModel.ToAgencyID || this.searchModel.ToAgencyID == null) {
          this.vehicleReservationCaseDetailsModel.dropOffLatitude = this.vehicleReservationCaseDetailsModel.latitude;
          this.vehicleReservationCaseDetailsModel.dropOffLongitude = this.vehicleReservationCaseDetailsModel.longitude;
        }
        this.lstPolicyReservationCaseModel = res.lstPolicyReservationCaseModel;
        this.bookingService.updateVehicleReservationCaseDetails(res);
        res.lstAdditionalServiceReservationCase.forEach(element => {
          this.updateFormDynamically(element);
          this.loadAdditionalServiceData(element);
        });
        this.form.updateValueAndValidity();

        this.cd.markForCheck();
      }
    });


  }

  //Load the Data for the additional Service controls
  loadAdditionalServiceData(element: LstAdditionalServiceReservationCase) {

    switch (element.predefinedAdditionalServiceID) {
      case PredefinedAdditionalServiceEnum.Drivers:
        this.bookingService.getDriverSkills()
          .subscribe(res => {

            this.driverSkills = res;
          });
        break;
      case PredefinedAdditionalServiceEnum.OneWayRentalService:

        this.bookingService.getOneWayRentalLocaions(element.agencyID, null, ModeType.Add, null, this.vehicle.classID, this.vehicle.makeID, this.vehicle.modelID, this.vehicle.year, this.vehicle.vehicleID)
          .subscribe(res => {


            this.oneWayRentalLocations = res;

            if (this.searchModel.ToAgencyID != null && this.searchModel.AgencyID != this.searchModel.ToAgencyID) {
              this.oneWayRentalServiceID = this.searchModel.ToAgencyID;
              let additionalServices = this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase.filter(a => a.additionalServiceTypeID == AdditionalServiceType.Service);
              let oneWayAdditionalService = additionalServices.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService)[0];
              let selectedOneWayRentalService = this.oneWayRentalLocations.filter(a => a.returnAgencyID == this.oneWayRentalServiceID)[0];

              this.vehicleReservationCaseDetailsModel.dropOffLatitude = selectedOneWayRentalService.latitude;
              this.vehicleReservationCaseDetailsModel.dropOffLongitude = selectedOneWayRentalService.longitude;
              if (this.form.controls[this.formControlPrefix + element.additionalServiceID] != null) {
                this.form.controls[this.formControlPrefix + element.additionalServiceID].setValue(selectedOneWayRentalService)
              }
              else {

                this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: selectedOneWayRentalService, disabled: false }))
              }
            }
            //Incase of it select by default so do not switch off the toggle(that we enabled in updateFormDynamically)
            else if (element.isMandatory || element.isSelectedByDefault) {

            }
            else {
              if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
                this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(false);
                this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
              }

            }
            this.cd.markForCheck();
            this.changeForm(this.form);

          });

        break;
      case PredefinedAdditionalServiceEnum.CrossingBoarders:
        this.bookingService.getCrossBorders(element.agencyID)
          .subscribe(res => {

            this.crossBorders = res;

          });
        break;
    }
  }

  //Get the VehicleReservationCaseDetailsModel and Iterate it
  //Build the form based on the predefinedAdditionalServiceID and what it have (DropDown, List of values ..etc)
  //The default case is only number or toggle without number
  updateFormDynamically(element: LstAdditionalServiceReservationCase) {


    let isDisabledServiceContent = true;

    if (element.isSelectedByDefault && element.isMandatory) {
      if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue({ value: true, disabled: true });
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
      }
      else {
        this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl({ value: true, disabled: true }))
      }
      isDisabledServiceContent = false;
    }
    else if (element.isSelectedByDefault) {
      if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue({ value: true });
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
      }
      else {
        this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl({ value: true }))
      }
      isDisabledServiceContent = false;

    }
    else if (element.isMandatory) {
      if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue({ value: true, disabled: true });
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
      }
      else {
        this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl({ value: true, disabled: true }))
      }
      isDisabledServiceContent = false;
    }
    else if (!element.isMandatory && !element.isSelectedByDefault) {
      if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(false);
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].enable();
        this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
      }
      else {
        this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      }

    }


    //Todo: move to switch case rather than if else, (built withiin testing )
    if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: true }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + "_RentalDeliveryFirstValidation", new FormControl(null));

      this.form.addControl(this.formControlPrefix + element.additionalServiceID,
        new FormGroup({
          PickUpToggle: new FormControl({ value: false, disabled: isDisabledServiceContent }),
          PickUpLocationName: new FormControl({ value: '', disabled: isDisabledServiceContent }),
          PickUpLocation: new FormControl(null),
          ReturnToggle: new FormControl({ value: false, disabled: isDisabledServiceContent }),
          ReturnLocationName: new FormControl({ value: '', disabled: isDisabledServiceContent }),
          ReturnLocation: new FormControl(null),
        }),
      )
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.CrossingBoarders) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabledServiceContent }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + '_Borders', new FormArray([]));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: {}, disabled: isDisabledServiceContent }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.AdditionalDrivers) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabledServiceContent }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: 1, disabled: isDisabledServiceContent }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {

      

      if (!element.isMandatory && !element.isSelectedByDefault) {
        if (this.searchModel.ToAgencyID != null && this.searchModel.AgencyID != this.searchModel.ToAgencyID) {
          if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(true);
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].enable();
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
          }
          else {
            this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl({ value: true, disabled: false }))
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].enable();
          }


        }
        else {
          if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(false);
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
          }
          else {
            this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
          }

          if (this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix] != null) {
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(false);
            this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].updateValueAndValidity();
          }

        }
      }


      //If one way rental data loaded then it add this control , else we will add it here and it will update it
      if (this.oneWayRentalLocations == null || this.oneWayRentalLocations.length == 0) {
        this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl(null))
      }
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl(0));

    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.Drivers) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabledServiceContent }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: [], disabled: isDisabledServiceContent }))
    }
    else {

      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      if (element.isMandatory || element.isSelectedByDefault) {
        this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: 1, disabled: false }))
      }
      else {
        this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: 1, disabled: true }))
      }
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: true }));

    }

    this.changeDisable(element);

    //this.changeDisable(element);


  }



  //Handle toggle for the controls dynamically
  changeDisable(additionalService: LstAdditionalServiceReservationCase) {

    //If its rental delivery (Pickup location or DropUp or both)
    if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery) {
      let controlName = 's_' + additionalService.additionalServiceID;
      let controlNameToggle = controlName + '_toggle';
      let formGroup = this.form.controls[controlName] as FormGroup;
      //If the toggle enabled then enable the checkbox inside it "only"
      if (this.form.controls[controlNameToggle].value) {


        Object.keys(formGroup.controls).forEach(key => {
          // if (key.includes('Toggle')) {
          formGroup.controls[key].enable();

          //}

        });
        this.addValidatorsToForm(additionalService);


      }
      //Else disable the checkboxes
      else {
        Object.keys(formGroup.controls).forEach(key => {
          //if (key.includes('Toggle')) {
          formGroup.controls[key].disable();
          formGroup.controls[key].clearAsyncValidators();
          formGroup.controls[key].updateValueAndValidity();
          //}

        });
        let rentalDeliveryFirstValidation = 's_' + additionalService.additionalServiceID + "_RentalDeliveryFirstValidation";

        this.form.controls[rentalDeliveryFirstValidation].clearValidators();
        this.form.controls[rentalDeliveryFirstValidation].updateValueAndValidity();
        this.clearValidators(controlName, additionalService);
      }

    }
    else {

      //If Toggled enable the control else disable it
      //Here we have one control
      let controlName = 's_' + additionalService.additionalServiceID;
      let controlNameToggle = controlName + '_toggle';
      if (this.form.controls[controlNameToggle].value) {
        this.form.controls[controlName].enable();
        this.addValidatorsToForm(additionalService)
        //this.form.get(controlName).setValidators(Validators.required);
        //this.form.controls[controlName].setValidators(Validators.required);

        //If one way rental service
        if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {
          //this code needed to solve a bug in mat-select when resiting its value
          //Start
          //this.form.removeControl(controlName);
          let temp = this.oneWayRentalLocations.slice();
          this.oneWayRentalLocations = [];
          this.oneWayRentalLocations = temp;

          //this.form.addControl(controlName, new FormControl({ value: {} },[Validators.required]));
          //this.addValidatorsToForm(additionalService);
          //this.form.controls[controlName].updateValueAndValidity();
          //this.form.controls[controlName].setErrors({hello:'hello'});
          this.oneWayRentalFlag = true;
          //End
        }
      }
      else {
        this.form.controls[controlName].disable();
        this.clearValidators(controlName, additionalService);


        //Todo: make the two if statment as a one condition
        //If one way rental service
        if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {

          //this code needed to solve a bug in mat-select when resiting its value
          //Start
          //this.form.removeControl(controlName);
          let temp = this.oneWayRentalLocations.slice();
          this.oneWayRentalLocations = [];
          this.oneWayRentalLocations = temp;
          //this.form.addControl(controlName, new FormControl({ value: null },[Validators.required]));
          //this.addValidatorsToForm(additionalService);
          //this.form.controls[controlName].updateValueAndValidity();
          this.oneWayRentalFlag = false;
          //End


          //If the user disable one way rental service and the default search was to return to another location
          //Then make the return location as pickup and update find ur ideal car dropoff location
          if (this.searchModel.ToAgencyID != this.searchModel.AgencyID) {
            this.searchModel.ToAgencyID = this.searchModel.AgencyID;
            this.searchModel.DropOffLocationTypeID = AgencyReturnLocationTypes.Branch;
            //This should be dropofflocation model
            this.bookingService.updateDropOffLocation({ returnAgencyID: this.searchModel.AgencyID });
          }


          //#region Remove the NonWorkingHours Object if exist
          //Remove the NonWorkingHours Object if exist

          let detailsModel = this.vehicleReservationCaseDetailsModel;
          if (detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.length > 0) {
            let pickUpFees = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 1)[0];
            if (pickUpFees == null) {
              //
              detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel = [];
            }
            else {
              detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel = [pickUpFees];
            }

          }





          //Check the Working Hours Fees for PickUp
          this.updateWorkingHoursForNewAgency(detailsModel);



          detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
            item.isActive = true;
          })


          this.bookingService.updateVehicleReservationCaseDetails(detailsModel);
        //#endregion


        }


      }

    }


    this.changeForm(this.form);
  }



  updateWorkingHoursForNewAgency(detailsModel) {
    //after removing the previous one and here is the mode of disable the one way rental service
    //So we will maeke the return same as PickUp so we need to check if the new DropOff Agency(pickup) does have working hours fees
    //We need to make API request to check
    let req = {
      EndTimeStringSelected: this.searchModel.EndTimeString,
      EndDateStringSelected: this.searchModel.EndDateString,
      EndDate: this.searchModel.EndDate,
      DropOffLocationTypeID: this.searchModel.DropOffLocationTypeID,//agencyReturnLocationTypeID
      ToAgencyID: this.searchModel.AgencyID,


    }
    this.bookingService.getWorkingHoursSetting(req).subscribe(res => {
      if (res.isAllow) {

        this.vehicleReservationCaseDetailsModel.dropOffLatitude = this.vehicleReservationCaseDetailsModel.latitude;
        this.vehicleReservationCaseDetailsModel.dropOffLongitude = this.vehicleReservationCaseDetailsModel.longitude;
        let rentalDeliveryService = this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
        if (rentalDeliveryService != null) {
          let rentalDelevieryFormGroup = this.form.controls[this.formControlPrefix + rentalDeliveryService.additionalServiceID] as FormGroup;
          rentalDelevieryFormGroup.controls["ReturnLocationName"].setValue(null);
          rentalDelevieryFormGroup.controls["ReturnLocation"].setValue(null);
        }


        if (!res.isWithinWorkingHours) {



          //Todo: change nonWorkingHoursChargeTypeID to enum
          let item: LstVehicleReservationCaseNonWorkingHoursChargeModel = {
            unitPrice: res.charge,
            name: res.name,
            isTaxable: res.isTaxable,
            nonWorkingHoursChargeTypeID: 2,
            isActive: true,
            isDropOffAndOneWayRental: true
          };

          //Disable the previous one
          let offDelivery = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];

          if (offDelivery != null) {
            offDelivery.isActive = false;
          }

          detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.push(item);

        }
      }
      this.bookingService.updateVehicleReservationCaseDetails(detailsModel);
    })
  }


  //Add Validations to the form based on the Business Logic
  addValidatorsToForm(additionalService: LstAdditionalServiceReservationCase) {

    //No Required validation for Driver skills
    if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.Drivers) {
      return
    }

    let controlName = 's_' + additionalService.additionalServiceID;
    switch (additionalService.predefinedAdditionalServiceID) {
      case PredefinedAdditionalServiceEnum.CrossingBoarders:
        let controlNameBorders = 's_' + additionalService.additionalServiceID + '_Borders';
        this.form.get(controlNameBorders).setValidators(Validators.required);
        break;
      case PredefinedAdditionalServiceEnum.RentalDelivery:

        let rentalDeliveryFirstValidation = 's_' + additionalService.additionalServiceID + "_RentalDeliveryFirstValidation";

        this.form.get(rentalDeliveryFirstValidation).setValidators(Validators.required);


        this.rentalDeliveryErrors = true;
        let formGroup = this.form.controls[controlName] as FormGroup;

        Object.keys(formGroup.controls).forEach(key => {
          if (key.includes('Toggle')) {

            if (formGroup.controls[key].value) {

              this.form.controls[rentalDeliveryFirstValidation].setValue({});

              this.rentalDeliveryErrors = false;
            }

          }

        });
        break
      default:

        this.form.get(controlName).setValidators(Validators.required);
        break;
    }
  }

  clearValidators(controlName, additionalService) {

    switch (additionalService.predefinedAdditionalServiceID) {
      case PredefinedAdditionalServiceEnum.CrossingBoarders:
        let controlNameBorders = 's_' + additionalService.additionalServiceID + '_Borders';
        this.form.get(controlNameBorders).clearValidators();
        this.form.get(controlNameBorders).updateValueAndValidity();
        this.form.get(controlName).clearValidators();
        this.form.get(controlName).updateValueAndValidity();
        break;
      default:

        this.form.get(controlName).clearValidators();
        this.form.get(controlName).updateValueAndValidity();
        break;
    }
    //this.form.controls[controlName].clearValidators();
  }

  //Filter the Additional service based on AdditionalServiceType.Service
  getAdditionalServiceReservationCaseTypeService() {

    return this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase.filter(a => a.additionalServiceTypeID == AdditionalServiceType.Service);
  }
  //Filter the Additional service based on AdditionalServiceType.Charge
  get getAdditionalServiceReservationCaseTypeCharge() {
    if (this.vehicleReservationCaseDetailsModel == null) {
      return null;
    }
    return this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase.filter(a => a.additionalServiceTypeID == AdditionalServiceType.Charge);
  }


  driverSkillChange(val) {

    this.changeForm(this.form);
  }

  //Open Google-Map-Pin Component in a PopUp(Modal)
  //And let the user select a DropUp||Return location
  //Save the return Obj in the dynamic form
  //And display the formated location in the input
  openMapDialog(type, controlNameInput, controlName, additionalServiceID) {


    let circleCoordinate = null;
    //PickUp Location
    if (type == 1) {
      circleCoordinate = {
        lat: this.vehicleReservationCaseDetailsModel.latitude,
        lng: this.vehicleReservationCaseDetailsModel.longitude,
      }
    }
    //Return Location
    else if (type == 2) {

      circleCoordinate = {
        lat: this.vehicleReservationCaseDetailsModel.dropOffLatitude,
        lng: this.vehicleReservationCaseDetailsModel.dropOffLongitude,
      }
    }
    const dialogConfig = new MatDialogConfig();


    let rentalDeliveryService = this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
    let radius = rentalDeliveryService.rentalDeliveryServiceScopeValue;

    //dialogConfig.disableClose = true;
    dialogConfig.data = {
      isDraggable: true,
      disableClose: true,
      radius: radius,
      circleCoordinate: circleCoordinate
    }

    //To debug BUG 3540 uncomment the below line of code
    //circleCoordinate.lat=null;

    if (circleCoordinate.lat != null && circleCoordinate.lng != null) {
      const dialogRef = this.dialog.open(GoogleMapPinComponent, dialogConfig);

      dialogRef.componentInstance.locationNameResolved.subscribe(result => {
        if (result != null) {

          let rentalDelivery = this.form.controls[this.formControlPrefix + additionalServiceID] as FormGroup;
          rentalDelivery.controls[controlNameInput].setValue(result.address);
          rentalDelivery.controls[controlName].setValue(result);
          this.cd.markForCheck();
        }
      });
    }
    else {
      this.notifications.error("SomethingWrongHappened");
    }



  }
  //Handle the checkBox toggle for the DropUp||Return Location
  rentalDeliveryCheckBoxToggle(toggleName, controlNameObjName, controlNameInput, additionalService) {

    let controlName = this.formControlPrefix + additionalService.additionalServiceID;
    let formGroup = this.form.controls[controlName] as FormGroup;

    if (formGroup.controls[toggleName].value) {
      formGroup.controls[controlNameInput].enable();
      formGroup.controls[controlNameInput].setValidators(Validators.required);
      let formControl = this.form.get(controlName + '.' + controlNameInput);

    }
    else {
      formGroup.controls[controlNameInput].disable();
      this.clearValidators(this.formControlPrefix + additionalService.additionalServiceID + "." + controlNameInput, additionalService);

      let rentalDelivery = this.form.controls[this.formControlPrefix + additionalService.additionalServiceID] as FormGroup;
      rentalDelivery.controls[controlNameInput].setValue(null);
      rentalDelivery.controls[controlNameObjName].setValue(null);
    }

    if (controlNameInput == "PickUpLocationName") {
      this.pickupLocationFlag = !this.pickupLocationFlag;

    }
    else {
      this.returnLocationFlag = !this.returnLocationFlag;
    }

    let rentalDeliveryFirstValidation = 's_' + additionalService.additionalServiceID + "_RentalDeliveryFirstValidation";

    if (!this.pickupLocationFlag || !this.returnLocationFlag) {
      //IF pick up or return checked , clear required validation
      this.form.get(rentalDeliveryFirstValidation).setValue({})
    }
    else {
      //IF pick up and return not checked and the main switch is toggled then throw required validation
      this.form.get(rentalDeliveryFirstValidation).setValue(null)
    }

    this.changeForm(this.form);

  }

  inputChanged() {

    this.changeForm(this.form);
  }

  OneWayRentalChanged(model: OneWayRentalModel, additionalService) {


    this.searchModel.ToAgencyID = model.returnAgencyID;
    this.searchModel.DropOffLocationTypeID = model.agencyReturnLocationTypeID;
    if (model != null) {

      let req = {
        EndTimeStringSelected: this.searchModel.EndTimeString,
        EndDateStringSelected: this.searchModel.EndDateString,
        EndDate: this.searchModel.EndDate,
        DropOffLocationTypeID: model.agencyReturnLocationTypeID,
        ToAgencyID: model.returnAgencyID,


      }
      this.bookingService.getWorkingHoursSetting(req).subscribe(res => {



        if (res.isAllow) {
          this.bookingService.updateDropOffLocation(model);


          this.vehicleReservationCaseDetailsModel.dropOffLatitude = model.latitude;
          this.vehicleReservationCaseDetailsModel.dropOffLongitude = model.longitude;
          let rentalDeliveryService = this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
          if (rentalDeliveryService != null) {
            let rentalDelevieryFormGroup = this.form.controls[this.formControlPrefix + rentalDeliveryService.additionalServiceID] as FormGroup;
            rentalDelevieryFormGroup.controls["ReturnLocationName"].setValue(null);
            rentalDelevieryFormGroup.controls["ReturnLocation"].setValue(null);
          }
          let detailsModel = this.vehicleReservationCaseDetailsModel;

          //Remove any previous nonworking hours
          //let preivousNonWorkingHourObj = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isDropOffAndOneWayRental)[0];
          let preivousNonWorkingHourObj = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];
          if (preivousNonWorkingHourObj != null) {
            let index = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(preivousNonWorkingHourObj, 0);
            if (index > -1) {
              detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

            }
          }
          //Else there is no previous from changing one way rental , but there is one from search result
          // else if (detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.length > 0 && res.charge == 0) {
          //   detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel[0].isActive = false;
          // }

          if (!res.isWithinWorkingHours) {



            //Todo: change nonWorkingHoursChargeTypeID to enum
            let item: LstVehicleReservationCaseNonWorkingHoursChargeModel = {
              unitPrice: res.charge,
              name: res.name,
              isTaxable: res.isTaxable,
              nonWorkingHoursChargeTypeID: 2,
              isActive: true,
              isDropOffAndOneWayRental: true
            };

            //Disable the previous one
            let offDelivery = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];

            if (offDelivery != null) {
              offDelivery.isActive = false;
            }

            detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.push(item);

          }
          else {
            // detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
            //   item.isActive = true;
            // })
          }
          this.bookingService.updateVehicleReservationCaseDetails(detailsModel);


          this.changeForm(this.form);
        }
        else {

          let detailsModel = this.vehicleReservationCaseDetailsModel;
          let dropOffAndOneWayRental = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isDropOffAndOneWayRental)[0];
          if (dropOffAndOneWayRental != null) {
            let index = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(dropOffAndOneWayRental, 0);
            if (index > -1) {
              detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

            }
          }
          detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
            item.isActive = true;
          })
          this.bookingService.updateVehicleReservationCaseDetails(detailsModel);

          this.form.controls[this.formControlPrefix + additionalService.additionalServiceID].setValue(null);
          this.bookingService.getOneWayRentalLocaions(additionalService.agencyID, null, ModeType.Add, null, this.vehicle.classID, this.vehicle.makeID, this.vehicle.modelID, this.vehicle.year, this.vehicle.vehicleID)
            .subscribe(res => {


              this.oneWayRentalLocations = res;

              this.cd.markForCheck();
              this.changeForm(this.form);

            });


          this.translate.get('SorryCantReturnOutsideWorkingHours').subscribe(res => {
            this.notifications.warn("<span>" + res + "</span>", null, {
              timeOut: 30000,
              showProgressBar: false,
              pauseOnHover: true,
              clickToClose: true,
              fade: true,
              actions: [{
                action: "Allow",
              }],
              icons: {
                error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
                warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
              }
            });
          })


        }
      })

    }


  }

  changeForm(model) {

    this.bookingData.next(new FormGroup(model.controls));
  }

  loadTermsAndCondition() {

    //Check if not loaded before
    if (this.TermsAndCondition == null || this.TermsAndCondition == '') {
      this.bookingService.getTermsAndCondition(this.searchModel.AgencyID).subscribe(res => {
        this.TermsAndCondition = res;
      });

    }
  }

  loadAdditionalServiceIcon(additionalService: LstAdditionalServiceReservationCase) {
    if (additionalService.iconUrl == null) {

      this.attachmentService.imageHandler(additionalService.additionalServiceID, AttachmentScopesEnum.Setting, AttachmentTypeEnum.AdditionalServicesIcon).subscribe(res => {

        //let sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(res)
        additionalService.iconUrl = res + '';
        this.cd.markForCheck();
      })
    }
    return additionalService.iconUrl;
  }

  compareOneWayRentalsId(obj1, obj2) {

    return (obj1.returnAgencyID + "") === (obj2.returnAgencyID + "");
  }

  checkIFValidQuantity(value, additionalService: LstAdditionalServiceReservationCase) {


    if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.AdditionalDrivers) {
      this.changeForm(this.form);
      return;
    }

    if (value > additionalService.maxQuantityAllowed) {
      this.form.controls[this.formControlPrefix + additionalService.additionalServiceID].setValue(additionalService.maxQuantityAllowed);
    }

    if (value <= 0) {
      this.form.controls[this.formControlPrefix + additionalService.additionalServiceID].setValue(1);
    }



    this.changeForm(this.form);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }





  //This is for Prevent user from copy paste on input fileds

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('keydown', ['$event'])
  public onKeydownHandler(e: KeyboardEvent): void {
    if (e.keyCode === 13) {
      alert("enter")
    }
  }
}



